import { createFileRoute } from '@tanstack/react-router'
import { Automations } from '@/features/b2b2c/automations'

export const Route = createFileRoute('/_authenticated/b2b2c/automations/')({
  component: Automations,
})
